import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  RadioGroupForm,
  Heading,
} from "@ogt/ui";

export const APPEAL_FOR_MYSELF = "appelformyself";
export const PARENT = "parent";
export const FIDUCIARY = "fiduciary";
export const HAVE_FIDUCIARY = "havefiduciary";

export default function AppealForWho() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 77;
  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          const prev = formData.appealforwho;
          const next = values.appealforwho;

          const otherRoles = [FIDUCIARY, HAVE_FIDUCIARY, PARENT];

          const switchedBetweenSelfAndOther =
            (prev === APPEAL_FOR_MYSELF && otherRoles.includes(next)) ||
            (otherRoles.includes(prev) && next === APPEAL_FOR_MYSELF);

          setFormData({
            ...formData,
            ...values,
            ...(switchedBetweenSelfAndOther && {
              firstname: "",
              lastname: "",
              email: "",
              phone: "",
              reporterEmail: "",
            }),
          });

          navigate("/kontaktuppgifter");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          appealforwho: Yup.string().test(
            "at-least-one-radio-selected",
            "Vänlig ange vem du överklagar som",
            (value) => {
              return (
                value === APPEAL_FOR_MYSELF ||
                value === FIDUCIARY ||
                value === HAVE_FIDUCIARY ||
                value === PARENT
              );
            }
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading
                  headingRef={h2Ref}
                  focusable
                  id="appealForWhoHeading"
                  progress={progress}
                >
                  Vem överklagar du för?
                </Heading>

                <p>
                  Om resenären är under 18 år behöver du ange en mejladress till
                  en vårdnadshavare, god man eller ett ombud.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <RadioGroupForm
                  name="appealforwho"
                  ariaLabelledBy="appealforwho"
                  options={[
                    {
                      id: "appelformyself",
                      value: "appelformyself",
                      label: "Jag överklagar för mig själv",
                    },
                    {
                      id: "parent",
                      value: "parent",
                      label: "Jag är vårdnadshavare/förälder åt resenären",
                    },
                    {
                      id: "fiduciary",
                      value: "fiduciary",
                      label: "Jag är god man/ombud åt resenären",
                    },
                    {
                      id: "havefiduciary",
                      value: "havefiduciary",
                      label: "Jag har en god man/ett ombud",
                    },
                  ]}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button onClick={handleSubmitClick(formRef)} type="submit">
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
